/** Required visual slots stay equipped; removal compares the selected item with current authority. */
export function canUnequip(equipment,slot,expectedItemId){return slot==='charm'&&typeof expectedItemId==='string'&&expectedItemId.length>0&&equipment.charm===expectedItemId;}
